module.exports = __webpack_public_path__ + "img/ejournal-logo-white.b52c32dd.svg";